import { useRouter } from 'next/router';
import React from 'react';
import { Button, Result } from 'antd';
import { FormattedMessage } from 'react-intl';
import { PageRestaurantActivate } from 'src/consts/routes';

const UnactivatedResult = () => {
  const router = useRouter();

  const gotoActivated = () => {
    router.push({
      pathname: PageRestaurantActivate,
      query: {
        from: router.pathname,
      },
    });
  };

  return (
    <Result
      status="500"
      title="500"
      subTitle={<FormattedMessage id="restaurant-unactivated" />}
      extra={
        <Button type="primary" onClick={gotoActivated}>
          <FormattedMessage id="action.activateRestaurant" />
        </Button>
      }
    />
  );
};

export default UnactivatedResult;
